export default {
  title: 'Seguir pedido',
};
